import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPackageAudit {
  id: number;
  type: string;
  pac_id: number;
  barcode: string;
  desi: string;
  oldDesi: string;
  @Type(() => Date)
  date: string;
  status: number;
  recalculatePrice: number;
}

export class IIPackageAuditListResponse extends IPagination {
  @Type(() => IPackageAudit)
  results: IPackageAudit[];
}

export class IPackageAuditQueryDto extends IQueryPaginationDto {
  pac_id?: string | number;
}
